import { render, staticRenderFns } from "./EditorCadastro.vue?vue&type=template&id=7fc2d938&"
import script from "./EditorCadastro.vue?vue&type=script&lang=js&"
export * from "./EditorCadastro.vue?vue&type=script&lang=js&"
import style0 from "@core/scss/vue/libs/quill.scss?vue&type=style&index=0&lang=scss&"
import style1 from "./EditorCadastro.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports